import Cache from '@/helper/Cache.js'
import Vue from 'vue'
import BzbsApi from '@/core/Http/BzbsApi.js'
import Account from '@/helper/AccountHelper.js'

export default {
  config: function () {
    return Vue.bzbsConfig
  },
  app_id: function () {
    if (Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')) != null) {
      if (
        Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).appId !=
        undefined
      ) {
        return Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).appId
      } else {
        return Account.getCacheCustom('app_id')
      }
    } else {
      return Account.getCacheCustom('app_id')
    }
  },
  getConfig() {
    var bzbBlobUrl = this.config().bzbBlobUrl + '/crmplus-consumer/config.json'
    return new Promise((resolve, reject) => {
      BzbsApi.connectBzbsGetBlob(bzbBlobUrl)
        .then(response => {
          var blob = response.data
          resolve(blob)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getConfigPasscode() {
    var bzbBlobUrl =
      this.config().bzbBlobUrl +
      '/crmplus-consumer/' +
      this.app_id() +
      '/PasscodeConfig.json'

    return new Promise((resolve, reject) => {
      BzbsApi.connectBzbsGetBlob(bzbBlobUrl)
        .then(response => {
          var blob = response.data
          resolve(blob)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getConfigEcommerceBrand() {
    var bzbBlobUrl =
      this.config().bzbBlobUrl +
      '/ecommercebrand/' +
      this.app_id() +
      '/appConfig'

    return new Promise((resolve, reject) => {
      BzbsApi.connectBzbsGetBlob(bzbBlobUrl)
        .then(response => {
          var blob = response.data
          resolve(blob)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getConfigCompanytext() {
    var bzbBlobUrl =
      this.config().bzbBlobUrl +
      '/crmplus-consumer/' +
      this.app_id() +
      '/companytext.json' 
    return new Promise((resolve, reject) => {
      BzbsApi.connectBzbsGetBlob(bzbBlobUrl)
        .then(response => {
          var blob = response.data
          resolve(blob)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getConfigEarnPoint() {
    var bzbBlobUrl =
      this.config().bzbBlobUrl +
      '/ecommercebrand/' +
      this.app_id() +
      '/Earnpointviacode.jpg' 

    return new Promise((resolve, reject) => {
      BzbsApi.connectBzbsGetBlob(bzbBlobUrl)
        .then(response => {
          var blob = response
          resolve(blob)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getCookies() {
    var locale = Cache.get('BzbsLocale') ? Cache.get('BzbsLocale') : 'en'
    var urlLocale =
      this.config().bzbBlobUrl +
      '/crmplus-consumer/cookies/' +
      locale +
      '/cookies_' +
      locale +
      '.json'
    return new Promise((resolve, reject) => {
      BzbsApi.connectBzbsGetBlob(urlLocale)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
